import script from "./ConsultationFab.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConsultationFab.vue?vue&type=script&setup=true&lang=ts"

import "./ConsultationFab.vue?vue&type=style&index=0&id=170552f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-170552f3"]])

export default __exports__